import React from "react";
import PropTypes from "prop-types";
import { Button, Form, FormGroup } from "reactstrap";

import TextInput from "../Shared/Forms/TextInput";
import SelectInput from "../Shared/Forms/SelectInput";
import DatePicker from "../Shared/Forms/DatePicker";
import TextArea from "../Shared/Forms/TextArea";
import { sportTypeOptions } from "./config/formOptionElements";

function formIsValid(userInput) {
  const { name, title, email, description } = userInput;

  return name.isValid && title.isValid && email.isValid && description.isValid;
}

function RequestForm(props) {
  const {
    handleInputChange,
    handleDateInputChange,
    handleFormSubmit,
    userInput
  } = props;

  const { name, email, title, sport, due, description } = userInput;

  return (
    <Form onSubmit={handleFormSubmit} className="container-fluid">
      <TextInput
        stateKey="title"
        labelText="Request Title"
        userInput={title}
        invalidMessage="Please give your request a title"
        onChange={handleInputChange}
      />

      <SelectInput
        stateKey="sport"
        labelText="Sport"
        userInput={sport}
        validate={false}
        onChange={handleInputChange}
      >
        {sportTypeOptions}
      </SelectInput>

      <FormGroup row>
        <label className="col-12">Due Date</label>
        <DatePicker
          name="due"
          value={due.val}
          onChange={handleDateInputChange}
        />
      </FormGroup>

      <TextArea
        userInput={description}
        labelText="Request Details"
        stateKey="description"
        invalidMessage="Please give us some details about your request"
        rows={6}
        onChange={handleInputChange}
      >
        <p>
          To help fulfill your request, please give lots of details, such as:
        </p>
        <ul>
          <li>Types of videos you need</li>
          <li>Your phone number</li>
          <li>Date, time and location of an event</li>
          <li>Length requirements for video</li>
        </ul>
      </TextArea>

      <TextInput
        stateKey="name"
        labelText="Your Name"
        userInput={name}
        invalidMessage="Please enter a valid name"
        onChange={handleInputChange}
      />

      <TextInput
        stateKey="email"
        labelText="Your Email"
        userInput={email}
        invalidMessage="Please enter a valid email address"
        onChange={handleInputChange}
      />

      <Button
        disabled={!formIsValid(userInput)}
        color="primary"
        size="lg"
        type="submit"
      >
        Submit
      </Button>
    </Form>
  );
}

RequestForm.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  handleDateInputChange: PropTypes.func.isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  userInput: PropTypes.object.isRequired
};

export default RequestForm;



// WEBPACK FOOTER //
// ./src/Video/RequestForm.js